require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-glennsl-bs-jest.json") })
        }
      }, "path---package-glennsl-bs-jest");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-glennsl-bs-jest!./.cache/json/package-glennsl-bs-jest.json
// module id = 863
// module chunks = 231608221292675